module.exports = __webpack_public_path__ + "img/start.2b11f84c.svg";